/**
 * Product identity, read at build time from VITE_PRODUCT_NAME / VITE_PRODUCT_TAGLINE (frontend/.env, overridable per
 * deployment). index.html reads the same two values through Vite's %VITE_…% substitution.
 */
const env = import.meta.env || {};

export const PRODUCT_NAME = env.VITE_PRODUCT_NAME || 'CPV';
export const PRODUCT_TAGLINE = env.VITE_PRODUCT_TAGLINE || 'Continued Process Verification';
